
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-defi-framework/api/v20-dev/get_token_allowance",
      function () {
        return require("private-next-pages/docs/komodo-defi-framework/api/v20-dev/get_token_allowance/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-defi-framework/api/v20-dev/get_token_allowance"])
      });
    }
  